import { useEffect, useRef } from 'react';
import { DotLottie } from '@lottiefiles/dotlottie-web';

const LOTTIE_SRC = '/animations/app-icon-white.lottie';

export const LottieAppIcon: React.FC<{ className?: string; active?: boolean }> = ({ className, active = true }) => {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const animationRef = useRef<DotLottie | null>(null);
    const playedRef = useRef(false);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const animation = new DotLottie({
            canvas,
            src: LOTTIE_SRC,
            loop: false,
            autoplay: false,
        });
        animationRef.current = animation;

        return () => {
            animation.destroy();
            animationRef.current = null;
        };
    }, []);

    useEffect(() => {
        const animation = animationRef.current;
        if (!animation) return;
        if (!active) return;
        if (playedRef.current) return;
        playedRef.current = true;
        animation.stop();
        animation.play();
    }, [active]);

    return (
        <div className={className}>
            <canvas ref={canvasRef} className="w-full h-full" />
        </div>
    );
};

export default LottieAppIcon;